import * as React from 'react';
import { useSession } from '../hooks/useSession';
import Drawer from './Drawer';
import Menu from './Menu';
import View from './View';

export default function AppMain() {
    const { page } = useSession();

    return (
        <Drawer>
            <Menu />
            <main className="main ">
                <View page={page} />
            </main>
        </Drawer>
    );
}
